var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"label":"Аналитик ЦЭККМП","value":_vm.value,"items":_vm.getAnalyst,"item-text":"fio","item-value":"id"},on:{"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }